import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useModal } from 'components/modals/ModalContext';
import { useOrderableModuleFeatures } from '../../views/settings/billing/functions/useOrderableModuleFeatures';
import ModuleOrderModal from '../../views/settings/billing/ModuleOrderModal';

// Badge which orders an unavailable feature as module or links to the upgrade wizard
const FeatureBadge: React.FC<{ feature?: string, onClick?: () => void }> = ({ feature, onClick }) => {
    const { t } = useTranslation();
    const { initializeModal } = useModal();
    const moduleFeatures = useOrderableModuleFeatures();

    // Determine if the feature is orderable as module within the current package
    const isOrderable = !!feature && !!moduleFeatures?.orderableFeatures.includes(feature);

    // Open the module order modal with the module information and payment button
    const handleOrderModuleClick = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        initializeModal(
            <ModuleOrderModal feature={feature!} />, {
                modalSize: 'small-medium'
            }
        );
        if (onClick) {
            onClick();
        }
    };

    // Show the order module badge which opens the module order modal
    if (isOrderable) {
        return (
            <span className='order-module-badge' onClick={handleOrderModuleClick}>
                {t('billing.order_module_badge_label')}
            </span>
        );
    }

    // Otherwise show the upgrade badge which preselects the package containing the feature
    return (
        <Link className='upgrade-badge'
              to={`/settings/billing/subscription/wizard?step=package${feature ? `&feature=${feature}` : ''}`}
              onClick={onClick}>
            {t('billing.upgrade_badge_label')}
        </Link>
    );
};

export default FeatureBadge;
